<div class="standard-transcript">
  @for (paragraph of paragraphs; track $index) {
    <div
      class="standard-transcript__paragraph"
      aria-hidden="true"
      (mouseenter)="onMouseToggle($index)"
      (mouseleave)="onMouseToggle($index)"
      (click)="onClick($index)"
    >
      <div
        class="standard-transcript__paragraph-value"
        cvRenderParagraph
        [paragraphData]="paragraph.words"
        [currentAudioTime]="currentAudioTime"
        [attr.data-owner]="paragraph.channel === EChannel.agent ? agentName : userName"
        [ngClass]="paragraph.channel === EChannel.agent ? 'agent' : 'user'"
      ></div>

      @if (hoveredParagraphIndex() === $index) {
        <div
          class="standard-transcript__paragraph-actions"
          [ngClass]="paragraph.channel === EChannel.user ? 'user-actions' : ''"
        >
          <button
            class="standard-transcript__paragraph-actions-button"
            (click)="playFromParagraph.emit(paragraph.words[0].start)"
          >
            <img ngSrc="assets/icons/circle-play-regular.svg" alt="play icon" height="16" width="16" />
          </button>
        </div>
      }
    </div>
  }
</div>
